import React from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Import styles
import { fadeIn } from 'components/styles';

// Import components
import { Button } from 'components/elements';
import Timer from './Timer';

// Import utilities
import { useNextMaterial } from 'components/utilities';

const NextEpisode = ({ setEndMargin, toggle }) => {
	const { t } = useTranslation();
	const { next } = useSelector((state) => state.movieDetails.episodes);
	const { fetchNextMaterial } = useNextMaterial();

	const handleCancelNextEpisode = () => {
		// Turn off end margin
		setEndMargin();
		// Close nextEpisode box
		toggle();
	};

	return (
		<Wrapper>
			<Text>
				{t('player_next_episode_desc')}
				<Timer />
			</Text>
			<Controllers>
				<Button
					onClick={handleCancelNextEpisode}
					modifiers="primaryVod"
					cancel={true}
					resume
				>
					{t('player_next_episode_btn_cancle')}
				</Button>
				<ButtonPlayNext
					onClick={fetchNextMaterial.bind(null, next?.uuid)}
					resume
					borderColor
					modifiers="primaryVod"
				>
					{t('player_next_episode_btn_play_next')}
				</ButtonPlayNext>
			</Controllers>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	position: absolute;
	right: 4rem;
	bottom: 12rem;
	z-index: 999;
	animation: ${fadeIn(0)} 0.5s ease-in-out forwards;
`;

const Text = styled.p`
	font-size: 1.2rem;
	font-weight: ${({ theme }) => theme.font.normal};
	color: #6b6b6b;
	padding: 0.6rem 2rem 0.6rem 0;
	text-align: right;
	opacity: 0.8;
`;

const Controllers = styled.div`
	display: flex;
	justify-content: space-between;
`;

const ButtonPlayNext = styled(Button)`
	width: 18rem;
	margin-left: 1rem;
`;

NextEpisode.propTypes = {
	toggle: func.isRequired,
	setEndMargin: func.isRequired
};

export default NextEpisode;
